var map = {
	"./Server-Busy.None.svg": 2418,
	"./Server-Busy.OfflineDrop.svg": 2419,
	"./Server-Busy.Ssh.svg": 2420,
	"./Server-Busy.TentacleActive.svg": 2421,
	"./Server-Busy.TentaclePassive.svg": 2422,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2423,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2424,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2425,
	"./Server-Default.AzureCloudService.svg": 2426,
	"./Server-Default.AzureServiceFabricCluster.svg": 2427,
	"./Server-Default.AzureSubscription.svg": 2428,
	"./Server-Default.AzureWebApp.svg": 2429,
	"./Server-Default.Ftp.svg": 2430,
	"./Server-Default.Kubernetes.svg": 2431,
	"./Server-Default.None.svg": 2432,
	"./Server-Default.OfflineDrop.svg": 2433,
	"./Server-Default.Ssh.svg": 2434,
	"./Server-Default.TentacleActive.svg": 2435,
	"./Server-Default.TentaclePassive.svg": 2436,
	"./Server-Disabled.AzureCloudService.svg": 2437,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2438,
	"./Server-Disabled.AzureSubscription.svg": 2439,
	"./Server-Disabled.AzureWebApp.svg": 2440,
	"./Server-Disabled.Ftp.svg": 2441,
	"./Server-Disabled.Kubernetes.svg": 2442,
	"./Server-Disabled.None.svg": 2443,
	"./Server-Disabled.OfflineDrop.svg": 2444,
	"./Server-Disabled.Ssh.svg": 2445,
	"./Server-Disabled.TentacleActive.svg": 2446,
	"./Server-Disabled.TentaclePassive.svg": 2447,
	"./Server-HasWarnings.Ssh.svg": 2448,
	"./Server-HasWarnings.TentacleActive.svg": 2449,
	"./Server-HasWarnings.TentaclePassive.svg": 2450,
	"./Server-Healthy.AzureCloudService.svg": 2451,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 2452,
	"./Server-Healthy.AzureSubscription.svg": 2453,
	"./Server-Healthy.AzureWebApp.svg": 2454,
	"./Server-Healthy.Ftp.svg": 2455,
	"./Server-Healthy.Kubernetes.svg": 2456,
	"./Server-Healthy.None.svg": 2457,
	"./Server-Healthy.OfflineDrop.svg": 2458,
	"./Server-Healthy.Ssh.svg": 2459,
	"./Server-Healthy.TentacleActive.svg": 2460,
	"./Server-Healthy.TentaclePassive.svg": 2461,
	"./Server-NeedsUpgrade.TentacleActive.svg": 2462,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 2463,
	"./Server-Unavailable.AzureCloudService.svg": 2464,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 2465,
	"./Server-Unavailable.AzureSubscription.svg": 2466,
	"./Server-Unavailable.AzureWebApp.svg": 2467,
	"./Server-Unavailable.Ftp.svg": 2468,
	"./Server-Unavailable.Kubernetes.svg": 2469,
	"./Server-Unavailable.OfflineDrop.svg": 2470,
	"./Server-Unavailable.Ssh.svg": 2471,
	"./Server-Unavailable.TentacleActive.svg": 2472,
	"./Server-Unavailable.TentaclePassive.svg": 2473,
	"./Server-Unhealthy.AzureCloudService.svg": 2474,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 2475,
	"./Server-Unhealthy.AzureWebApp.svg": 2476,
	"./Server-Unhealthy.Kubernetes.svg": 2477,
	"./Server-Unhealthy.OfflineDrop.svg": 2478,
	"./Server-Unhealthy.Ssh.svg": 2479,
	"./Server-Unhealthy.TentacleActive.svg": 2480,
	"./Server-Unhealthy.TentaclePassive.svg": 2481,
	"./Server-Unknown.AzureCloudService.svg": 2482,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 2483,
	"./Server-Unknown.AzureSubscription.svg": 2484,
	"./Server-Unknown.AzureWebApp.svg": 2485,
	"./Server-Unknown.Ftp.svg": 2486,
	"./Server-Unknown.Kubernetes.svg": 2487,
	"./Server-Unknown.None.svg": 2488,
	"./Server-Unknown.OfflineDrop.svg": 2489,
	"./Server-Unknown.Ssh.svg": 2490,
	"./Server-Unknown.TentacleActive.svg": 2491,
	"./Server-Unknown.TentaclePassive.svg": 2492,
	"./Server-Warning.OfflineDrop.svg": 2493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2417;